import { SVGProps, Ref, forwardRef } from 'react'
const SvgBug = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M17.25 7.5a5.25 5.25 0 1 0-10.5 0v.75h10.5V7.5ZM6.75 18a5.25 5.25 0 0 0 10.5 0V8.25H6.75V18Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M16.594 4.959A4.5 4.5 0 0 0 19.5.75M7.406 4.959A4.5 4.5 0 0 1 4.5.75M17.25 12.75h6M23.25 18.75a6 6 0 1 1 0-12M6.75 12.75h-6M.75 18.75a6 6 0 1 0 0-12"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgBug)
export default ForwardRef
